import { Redirect, Route, Switch } from 'react-router-dom';
import $supplierName from './$supplierName';
import All from './all';
import Matched from './matched';
import Unmatched from './unmatched';

/**
 * @param {object} props
 * @param {import('react-router').match} props.match
 * @returns
 */
export default function MapSuppliersRoutes({ match }) {
  return (
    <Switch>
      {/* The index route: */}
      <Redirect exact from={`${match.path}`} to={`${match.url}/unmatched`} />

      <Route path={`${match.path}/all`} component={All} />
      <Route path={`${match.path}/matched`} component={Matched} />
      <Route path={`${match.path}/unmatched`} component={Unmatched} />
      <Route path={`${match.path}/:supplierName`} component={$supplierName} />
    </Switch>
  );
}
